<template>
  <div class="login-view">
    <login-form />
  </div>
</template>

<script>

  import LoginForm from 'brave-authentication/components/login'
  export default {
    name: 'LoginView',
    components: {
      'login-form': LoginForm
    }
  }
</script>





// WEBPACK FOOTER //
// apps/www.bravenet.com/src/views/login.vue